import createAction from '../createAction.js';
import Duck from '../Duck.js';
import hasStore from './checks/hasStoreCheck.js';

const legacyReducer = (state, action, duck) => {
    switch (action.type) {
        case duck.types.CLEAR: {
            return duck.primitiveState;
        }

        case duck.types.RESET: {
            return duck.initialState;
        }

        case duck.types.SET: {
            return action.payload;
        }

        default:
            return state;
    }
};

const rtkReducer = (builder, duck) => {
    builder
        .addCase(duck.types.CLEAR, (state, action) => duck.primitiveState)
        .addCase(duck.types.RESET, (state, action) => duck.initialState)
        .addCase(duck.types.SET, (state, action) => action.payload);
};

function primitiveDuckCreator(options = {}) {
    const {
        primitiveName,
        primitiveState = null,
        creators = {},
        types = [],
        ...restOptions
    } = options;

    hasStore(options.store, primitiveName);

    if (!options.initialState) {
        restOptions.initialState = primitiveState;
    }

    return new Duck({
        types: ['SET', 'RESET', 'CLEAR', ...types],
        reducer: options.useRTKReducer ? rtkReducer : legacyReducer,
        creators: (duck) => ({
            set: createAction(duck.types.SET),
            reset: createAction(duck.types.RESET),
            clear: createAction(duck.types.CLEAR),
            ...creators,
        }),
        primitiveState,
        ...restOptions,
    });
}

export { primitiveDuckCreator as default };
